import { FC, ReactNode } from 'react';

type Props = {
  label: string;
  children: ReactNode;
};

const MenuSection: FC<Props> = ({ label, children }) => {
  return (
    <div className="mt-6 first:mt-0">
      <div className="px-5 mb-2">
        <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-400">
          {label}
        </span>
      </div>
      <div className="space-y-0.5">
        {children}
      </div>
    </div>
  );
};

export { MenuSection };
